// extracted by mini-css-extract-plugin
export default {"border_color":"style_border_color__Vukz3","cursor_pointer":"style_cursor_pointer__ZW1N2"};